// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-dialog {\n  z-index: 2000 !important;\n  position: relative;\n}", ""]);
// Exports
module.exports = exports;
